module.exports = __webpack_public_path__ + "static/media/ksa.a56e7bd2.png";